import { experience } from './data/experience';
import { adjectives, awards, references, social } from './data/misc';
import { personalInfo } from './data/personal';
import { projects } from './data/projects';
import { skills } from './data/skills';
import { testimonials } from './data/testimonials';
import { PortfolioData } from './types';

// Main portfolio data object with proper typing
const portfolioData: PortfolioData = {
    personalInfo,
    experience,
    skills,
    projects,
    testimonials,
    social,
    awards,
    references,
    adjectives,
};

// Legacy compatibility - flatten the structure for existing components
const me = {
    // Personal info (flattened for backward compatibility)
    name: portfolioData.personalInfo.name,
    email: portfolioData.personalInfo.email,
    phone: portfolioData.personalInfo.phone,
    about: portfolioData.personalInfo.about,
    profile: portfolioData.personalInfo.profile,
    image: portfolioData.personalInfo.image,
    resume: portfolioData.personalInfo.resume,

    // Other data
    experience: portfolioData.experience,
    skills: portfolioData.skills,
    projects: portfolioData.projects,
    testimonials: portfolioData.testimonials,
    social: portfolioData.social,
    awards: portfolioData.awards,
    references: portfolioData.references,
    adjectives: portfolioData.adjectives,
};

export default me;

// Export typed data for new components
export { portfolioData };

// Export individual data modules for specific use cases
export { experience } from './data/experience';
export { adjectives, awards, references, social } from './data/misc';
export { personalInfo } from './data/personal';
export { getProjectImages, projects } from './data/projects';
export { skills } from './data/skills';
export { testimonials } from './data/testimonials';

// Export types for external use
export type * from './types';
